import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { red_colors, neutral_colors, green_colors, replaceEmoji, numberWithCommas } from "../utils";
import { getContrastYIQ } from "../../../../../lib/utils";
import HighChartsTreemap from "highcharts/modules/treemap";
import HighchartsCustomEvents from "highcharts-custom-events";
import NoData from "../NoData/NoData";

HighChartsTreemap(Highcharts);
HighchartsCustomEvents(Highcharts);

class TopTopicsChart extends React.PureComponent {
    state = {};
    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current && this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current && this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getGroupColour(net_score, sentiment) {
        if (net_score >= -2 && net_score <= 2) {
            return neutral_colors;
        } else if (net_score < -2) {
            let net_score_adjusted = Math.abs(Math.floor(net_score / 10));
            if (net_score_adjusted >= 4) {
                return red_colors[4];
            } else {
                return red_colors[net_score_adjusted];
            }
        } else {
            let net_score_adjusted = Math.floor(net_score / 10);
            if (sentiment === "negative") {
                if (net_score_adjusted >= 4) {
                    return red_colors[4];
                } else {
                    return red_colors[net_score_adjusted];
                }
            } else {
                if (net_score_adjusted >= 4) {
                    return green_colors[4];
                } else {
                    return green_colors[net_score_adjusted];
                }
            }
        }
    }

    getOptions = (points) => {
        let chartConfig = null;

        if (points?.length) {
            let self = this;
            chartConfig = {
                series: [
                    {
                        type: "treemap",
                        layoutAlgorithm: "squarified",
                        turboThreshold: 3000,
                        allowTraversingTree: true,
                        data: points,
                        animationLimit: 1000,
                        dataLabels: {
                            enabled: true,
                        },
                        levelIsConstant: false,
                        levels: [
                            {
                                level: 1,
                                dataLabels: {
                                    enabled: true,
                                },
                                borderWidth: 3,
                            },
                            {
                                level: 2,
                                dataLabels: {
                                    enabled: true,
                                },
                                borderWidth: 2,
                            },
                        ],
                    },
                ],
                title: false,
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    backgroundColor: "transparent",
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        fontSize: 12,
                    },
                    events: {
                        render: function (event) {
                            // adding abelCSS in svg for including font in png downloads
                            // let style = document.createElement("style");
                            // //style.appendChild(document.createTextNode(abelCss));
                            // const element = document.getElementById(event.target.container.id).firstChild;
                            // element.insertBefore(style, element.firstChild);

                            // datalabels visibility
                            var points = this.series[0].points;
                            points.forEach(function (point) {
                                if (point.dataLabel && point.shapeArgs) {
                                    if (point.shapeArgs.width < point.dataLabel.width / 2 || point.shapeArgs.height < point.dataLabel.height * 0.7) {
                                        point.dataLabel.hide();
                                    } else point.dataLabel.show();
                                }
                            });
                        },
                        redraw: function (event) {
                            if (document.getElementsByClassName("highcharts-drillup-button")[0])
                                document.getElementsByClassName("highcharts-drillup-button")[0].setAttribute("data-html2canvas-ignore", true);
                        },
                    },
                },

                credits: {
                    enabled: false,
                },
                plotOptions: {
                    treemap: {
                        allowTraversingTree: true,
                        cursor: "pointer",
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            overflow: "justify",
                            formatter: function (e) {
                                const fontColor = getContrastYIQ(this.point.hexColor);
                                e.style.color = fontColor;
                                e.style.stroke = fontColor;
                                if (this.point.shapeArgs) {
                                    let nodeWidth = this.point.shapeArgs.width;
                                    let nodeHeight = this.point.shapeArgs.height;
                                    let aspectRatio = nodeWidth / nodeHeight;
                                    let fontSize = 11;
                                    if (aspectRatio > 3) fontSize = ((nodeWidth * 11) / 100 - 4) / Math.sqrt(aspectRatio);
                                    else if (aspectRatio > 2) fontSize = ((nodeWidth * 11) / 100 - 4) / aspectRatio;
                                    else if (aspectRatio < 0.5) fontSize = ((nodeWidth * 11) / 80 - 4) * aspectRatio * aspectRatio * 10;
                                    else if (aspectRatio < 1) fontSize = ((nodeWidth * 11) / 80 - 4) * aspectRatio;
                                    else fontSize = (nodeWidth * 8) / 80 - 4;
                                    e.style.width = nodeWidth - 2 + "px";
                                    e.style.height = nodeHeight - 2 + "px";
                                    e.width = nodeWidth - 2;
                                    e.height = nodeHeight - 2;
                                    if (fontSize < 11) fontSize = 11;
                                    e.style.fontSize = fontSize + "px";
                                }
                                // console.log("this valueeee----", this.point.name, this.point.node, this.point.level);
                                if (this.point.level === 1 || (this.point.level === 2 && this.point.node?.children?.length > 0)) {
                                    e.style.textDecoration = "underline";
                                    // e.style.textDecorationColor = "blue";
                                    // e.style.textUnderlineOffset = "4px";
                                    // e.style.textDecorationThickness = "1px";
                                }
                                return replaceEmoji(this.point.name);
                            },
                            style: {
                                fontWeight: "normal",
                                color: "#000",
                                stroke: "#000",
                                textOutline: "0px",
                            },
                        },
                        point: {
                            events: !this.props.insights__recommendation
                                ? {
                                      click: function (e) {
                                          this.series.onClickDrillToNode(e);
                                      },
                                      contextmenu: function (e) {
                                          //   console.log(this);
                                          e.preventDefault();
                                          if (this.id === "others") return;
                                          if (this.type === "keyword") self.props.showContextMenu(e.x, e.y, this.parent, this.keywords);
                                          else self.props.showContextMenu(e.x, e.y, this.id);
                                      },
                                  }
                                : {},
                        },
                    },
                },
                tooltip: {
                    followPointer: true,
                    followTouchMove: true,
                    outside: true,
                    backgroundColor: "#fff",
                    borderRadius: 6,
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        // zIndex: 9999999,
                        zIndex: 10,
                    },
                    formatter: function () {
                        let sortType;
                        let obj =
                            self.props.appliedFilter && self.props.appliedFilter.clustering_sort_by ? self.props.appliedFilter.clustering_sort_by : "volume";

                        if (obj === "volume") sortType = "Volume";
                        else if (obj === "impact") sortType = "Impact Value";
                        else if (obj === "traction") sortType = "Traction";

                        return `<span>${this.point.name}</span><br/><span>${sortType} :</span> <b>${
                            Number.isInteger(this.point.value) ? numberWithCommas(this.point.value) : numberWithCommas(this.point.value.toFixed(3))
                        }</b><br/><span>Positive:</span> <b>${this.point.positive_percentage.toFixed(
                            2,
                        )}%</b><br/><span>Negative:</span> <b>${this.point.negative_percentage.toFixed(
                            2,
                        )}%</b><br/><span>Neutral: </span><b>${this.point.neutral_percentage.toFixed(2)}%</b>`;
                    },
                },
            };
            //if (this.state.showMoreLoading) this.setState({ showMoreLoading: false });
        }
        return chartConfig;
    };

    getData = () => {
        let points = [];
        let total_value = this.props.data.total_value;
        // let type = this.props.appliedFilter && this.props.appliedFilter.clustering_sort_by ? this.props.appliedFilter.clustering_sort_by : "volume";

        let data = this.props.showMore ? this.props.data.showMoreData : this.props.data.formatted_data;
        // if (data.length) {
        //     data.forEach((d) => {
        //         var net_sentiment_score = 0;
        //         net_sentiment_score = Math.floor(d.net_sentiment_score);
        //         let value;
        //         value = type === "volume" ? d.doc_count : type === "traction" ? d.traction : d.impact_score;
        //         const hexColor = this.getGroupColour(net_sentiment_score, this.props.sentiment);
        //         total_value += value;
        //         points.push({
        //             ...d,
        //             value: value,
        //             hexColor,
        //             color: radialColor(hexColor),
        //         });
        //     });
        // }
        return { points: data, total_value };
    };

    getChart = () => {
        let data = this.getData();

        if (data.total_value === 0) {
            let type = this.props.appliedFilter && this.props.appliedFilter.clustering_sort_by ? this.props.appliedFilter.clustering_sort_by : "volume";
            return <NoData message={`Not enough data available to "Sort by ${type}"`} />;
        } else
            return (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={this.getOptions(data.points)}
                    ref={this.chartComponent}
                    containerProps={{ style: { width: "100%", height: "100%" } }}
                />
            );
    };

    render() {
        return this.getChart();
    }
}

export default TopTopicsChart;
